import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import ProfilePage from "@/pages/ProfilePage";
import AchievementsPage from "@/pages/AchievementsPage";
import ChessGame from "@/components/chess/ChessGame";
import CheckersGame from "@/games/checkers/CheckersGame";
import TriangleCheckersGame from "@/games/checkers/TriangleCheckersGame";
import BaseballGame from "@/games/baseball/BaseballGame";
import BridgeGame from "@/games/bridge/BridgeGame";
import PokerHub from "@/games/poker/PokerHub";
import ThreeCardStud from "@/games/poker/ThreeCardStud";
import TexasHoldem from "@/games/poker/TexasHoldem";
import PokerLobby from "@/games/poker/PokerLobby";
import PokerMultiplayer from "@/games/poker/PokerMultiplayer";
import PokerPractice from "@/games/poker/PokerPractice";
import Solitaire from "@/games/solitaire/Solitaire";
import TeenPatti from "@/games/teenpatti/TeenPatti";
import TeenPattiLobby from "@/games/teenpatti/TeenPattiLobby";
import ReplayPage from "@/pages/ReplayPage";
import ResetPassword from "@/components/auth/ResetPassword";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/replay/:replayId" element={<ReplayPage />} />
          
          {/* Dashboard (requires login for full features) */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/achievements" element={<AchievementsPage />} />
          
          {/* Games (can be played as guest) */}
          <Route path="/games/chess" element={<ChessGame />} />
          <Route path="/games/checkers" element={<CheckersGame />} />
          <Route path="/games/triangle-checkers" element={<TriangleCheckersGame />} />
          <Route path="/games/baseball" element={<BaseballGame />} />
          <Route path="/games/bridge" element={<BridgeGame />} />
          <Route path="/games/poker" element={<PokerHub />} />
          <Route path="/games/poker/three-card-stud" element={<ThreeCardStud />} />
          <Route path="/games/poker/texas-holdem" element={<TexasHoldem />} />
          <Route path="/games/poker/lobby" element={<PokerLobby />} />
          <Route path="/games/poker/multiplayer/:tableId" element={<PokerMultiplayer />} />
          <Route path="/games/poker/practice" element={<PokerPractice />} />
          <Route path="/games/solitaire" element={<Solitaire />} />
          <Route path="/games/teen-patti" element={<TeenPatti />} />
          <Route path="/games/teen-patti/lobby" element={<TeenPattiLobby />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
